  function copyRechargeImage() {
    // 1. Get the element containing the content to copy
    const rechargeEl = document.querySelector('.recharge_image_login');
    if (!rechargeEl) {
      console.warn('No element with class "recharge_image_login" found.');
      return;
    }

    // 2. Get the container (.rc-login) and the sibling (.rc-login--body)
    const rcLogin = document.querySelector('.rc-login');
    if (!rcLogin) {
      console.warn('No element with class "rc-login" found.');
      return;
    }

    const rcLoginBody = rcLogin.querySelector('.rc-login--body');
    if (!rcLoginBody) {
      console.warn('No element with class "rc-login--body" found inside .rc-login.');
      return;
    }

    // 3. Create a new div and place the copied content inside it
    const newDiv = document.createElement('div');
    newDiv.classList.add('rc-login--rigby-image');
    newDiv.innerHTML = rechargeEl.innerHTML;

    // 4. Insert the new div as a sibling of .rc-login--body
    rcLogin.insertBefore(newDiv, rcLoginBody.nextSibling);
  }

  // Call the function (for example, once the DOM is fully loaded)
  document.addEventListener('DOMContentLoaded', copyRechargeImage);